import React, { FC, useCallback, useMemo } from 'react';

import { ModifierListItem } from './modifier-list-item';
import { IModifierTypeUIProps } from './types';
import {
  getModifierOptionMultiplier,
  getSingleSelectedOption,
  logProductModifierCustomization,
  transformSelectedOptionToSelections,
} from './utils';

export const ModifierCheckbox: FC<IModifierTypeUIProps> = ({
  modifier,
  selections,
  onSelectionsChange,
  selectedItem,
}) => {
  const selectedOption = useMemo(() => getSingleSelectedOption(selections), [selections]);

  const isSelected = getModifierOptionMultiplier(selectedOption) === 1;

  const onCardPress = useCallback(() => {
    const multiplierValue = isSelected ? 0 : 1;

    const newSelectedOption = modifier.options.find(
      opt => opt.modifierMultiplier?.multiplier === multiplierValue
    );

    if (!newSelectedOption) {
      return;
    }

    onSelectionsChange(transformSelectedOptionToSelections(newSelectedOption));

    logProductModifierCustomization(
      newSelectedOption.name?.locale ?? '',
      modifier.name.locale,
      newSelectedOption._key
    );
  }, [isSelected, modifier.options, modifier.name.locale, onSelectionsChange]);

  return (
    <ModifierListItem
      onCardPress={onCardPress}
      content={modifier}
      isSelected={isSelected}
      selectedItem={selectedItem}
      selectedOption={selectedOption}
    />
  );
};
